import { FiSearch } from "react-icons/fi";
import { useEffect, useState } from "react";
import { inviteServices } from "../../APIServices/UserData/inviteServices";
import { Button, Card, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import Moment from "react-moment";
import NoDataHere from "../../Img/nodatahere.png";
import { ListLoader } from "../../Hooks/PageLoader";
import { GrOrganization } from "react-icons/gr";

const InvitationForMe = ({ auth, getOrganizations }) => {
  const [invitedList, setInvitedList] = useState([]);
  const [invitedCount, setInvitedCount] = useState(0);

  const [searchData, setSearchData] = useState("");
  const [status, setStatus] = useState("all");
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(invitedCount / itemsPerPage);
  const [listLoader, setListLoader] = useState(false)

  const getApprovalInvitation = async () => {
    setListLoader(true)
    let data = await inviteServices.getApprovalInvitation(auth, status, searchData, pageNumber, itemsPerPage)
    setInvitedList(data?.data || [])
    setInvitedCount(data?.count || 0)
    setListLoader(false)
  }

  const acceptRejectInvitation = async (adminId, userId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${status} this Invitation?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status}} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.adminId = adminId
        userData.userId = userId
        userData.status = status
        let data = await inviteServices.acceptRejectInvitation(auth, userData)
        if (data?.statusCode === 200) {
          getApprovalInvitation()
          getOrganizations()
        }
      }
    });
  };

  useEffect(() => {
    getApprovalInvitation()
  }, [auth, status, searchData, pageNumber, itemsPerPage]);

  return (
    <div className="position-relative">
      <div className="p-2 hstack gap-2 border-bottom">
        <InputGroup>
          <Form.Select
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px", width: "20%" }}
            onChange={(e) => setStatus(e.target.value)}
            value={status}
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="accept">Accepted</option>
            <option value="reject">Rejected</option>
          </Form.Select>
          <FiSearch className="position-absolute" style={{ top: 11, left: "26.5%", zIndex: 99 }} />
          <Form.Control onChange={(e) => setSearchData(e.target.value)} values={searchData} type="search" className="interactive-input py-2 ps-5" title="Search Here..." style={{ fontSize: 12, width: "70%" }} placeholder={`Search by Name & Email...`} />
        </InputGroup>
      </div>
      <div style={{ height: "100vh" }}>
        {listLoader ? <ListLoader /> : invitedCount > 0 ? (
          <>
            <Container fluid>
              <Row>
                <Form.Group as={Col} md={12} className="p-0">
                  <div className="w-100 m-auto pb-1 pt-3 px-3">
                    <h5 className="fw-bold mb-1">Organization Invitation</h5>
                  </div>
                  <div className="w-100 m-auto p-3">
                    <Card className="border rounded-1 mb-3">
                      <Card.Body className="overflow-auto" style={{ maxHeight: "calc(100vh - 150px)" }}>
                        <Container fluid>
                          {invitedList?.map((item, index) => (
                            <Row key={index} className="my-3 align-items-center">
                              <Form.Group as={Col} md={3}>
                                <div className="d-flex gap-2 align-items-start">
                                  <span style={{ fontSize: 24 }} className="text-muted">
                                    <GrOrganization />
                                  </span>
                                  <div style={{ lineHeight: 1.3 }}>
                                    <h6 className="mb-1 fw-bold" style={{ fontSize: 14 }}>
                                      {item?.name}
                                    </h6>
                                    <Form.Label className="m-0 d-block" style={{ fontSize: 11 }}>
                                      <span>{item?.email}</span>
                                    </Form.Label>
                                  </div>
                                </div>
                              </Form.Group>
                              <Form.Group as={Col} md={2}>
                                <div style={{ lineHeight: 1.3 }}>
                                  <Form.Label className="m-0 d-block fw-bold" style={{ fontSize: 11 }}>
                                    Invitation DT
                                  </Form.Label>
                                  <Form.Label className="m-0 d-block" style={{ fontSize: 11 }}>
                                    <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                      {item?.inVitationDate}
                                    </Moment>
                                  </Form.Label>
                                </div>
                              </Form.Group>
                              <Form.Group as={Col} md={2}>
                                <div style={{ lineHeight: 1.3 }}>
                                  <Form.Label className="m-0 d-block fw-bold" style={{ fontSize: 11 }}>
                                    Accept / Reject DT
                                  </Form.Label>
                                  <Form.Label className="m-0 d-block" style={{ fontSize: 11 }}>
                                    {item?.acceptRejectDate ?
                                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                        {item?.acceptRejectDate}
                                      </Moment>
                                      : "NA"}
                                  </Form.Label>
                                </div>
                              </Form.Group>
                              <Form.Group as={Col} md={2}>
                                <div style={{ lineHeight: 1.3 }}>
                                  <Form.Label className="m-0 d-block fw-bold" style={{ fontSize: 11 }}>
                                    Invitation Status
                                  </Form.Label>
                                  <Form.Label className={`m-0 d-block text-capitalize ${item?.status === "accept" ? "text-success" : item?.status === "reject" ? "text-danger" : "text-warning"}`} style={{ fontSize: 11 }}>
                                    {item?.status === "accept" ? "Accepted" : item?.status === "reject" ? "Rejected" : "Pending"}
                                  </Form.Label>
                                </div>
                              </Form.Group>
                              <Form.Group as={Col} md={2}>
                                <div style={{ lineHeight: 1.3 }}>
                                  <Form.Label className="m-0 d-block fw-bold" style={{ fontSize: 11 }}>
                                    Access Status
                                  </Form.Label>
                                  <Form.Label className={`m-0 d-block text-capitalize ${item?.accessStatus === "granted" ? "text-success" : item?.accessStatus === "pending" ? "text-warning" : "text-danger"}`} style={{ fontSize: 11 }}>
                                    {item?.accessStatus}
                                  </Form.Label>
                                </div>
                              </Form.Group>
                              <Form.Group as={Col} md={1}>
                                <div className="hstack gap-2 justify-content-end">
                                  <Button
                                    onClick={() => acceptRejectInvitation(item?.adminId, item?.userId, "accept")}
                                    variant={item?.status === "pending" ? "outline-success" : "outline-secondary"}
                                    className="rounded-1 text-nowrap py-1 px-2"
                                    style={{ fontSize: 11 }}
                                    disabled={item?.status != "pending"}
                                    title="Accept Invitation"
                                  >
                                    Accept
                                  </Button>
                                  <Button
                                    onClick={() => acceptRejectInvitation(item?.adminId, item?.userId, "reject")}
                                    variant={item?.status === "pending" ? "outline-danger" : "outline-secondary"}
                                    className="rounded-1 text-nowrap py-1 px-2"
                                    style={{ fontSize: 11 }}
                                    disabled={item?.status != "pending"}
                                    title="Reject Invitation"
                                  >
                                    Reject
                                  </Button>
                                </div>
                              </Form.Group>
                            </Row>
                          ))}
                        </Container>
                      </Card.Body>
                    </Card>
                  </div>
                </Form.Group>
              </Row>
            </Container>
          </>
        ) : (
          <span className="small hstack justify-content-center h-100">
            <div className="text-center" style={{ pointerEvents: "none", userSelect: "none" }}>
              <img src={NoDataHere} style={{ width: 200, opacity: .1 }} alt="" />
              <p className="text-muted">There are no invitation.</p>
            </div>
          </span>
        )}
      </div>
    </div>
  );
};

export default InvitationForMe;
